import(/* webpackMode: "eager" */ "/build/app/[subdomain]/(device)/page.tsx");
